module.exports = __webpack_public_path__ + "img/69000.bd3bc387.jpg";